export default __webpack_public_path__ + "static/media/018.5c2eac10.jpg";